import { Fields, validations } from '..'

export function NewEmail({ register, errors, getValues }) {
  const matchesEmail = () => getValues('emailConfirmation') === getValues('emailToAdd') || 'Must match email address'

  return (
    <>
      <Fields.Text
        label="New Email Address *"
        error={!!errors.email}
        type="text"
        helperText={errors?.email?.message}
        InputProps={{
          inputProps: {
            'data-testid': 'emailToAdd',
          },
        }}
        {...register('emailToAdd', { ...validations.required, ...validations.email })}
      />
      <Fields.Text
        label="Repeat New Email Address *"
        error={!!errors.emailConfirmation}
        helperText={errors.emailConfirmation?.message}
        type="text"
        InputProps={{
          inputProps: {
            'data-testid': 'confirmEmail',
          },
        }}
        {...register('emailConfirmation', { ...validations.required, validate: { matchesEmail } })}
      />
    </>
  )
}
